import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store/store';
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';

import { RootState } from '../../../reducers';
import { setMemberBudget } from '../../../store/memberBudget.slice';
import classes from '../Styles';
import { copyObject } from '../../../utils/common';
import CurrencyInput from '../../Shared/CurrencyInput';

const RentExpenses = () => {
    const dispatch = useAppDispatch();
    const { memberBudget } = useSelector((state: RootState) => state.memberBudget);

    const handleOnChangeRentSource = (val: any, index: number) => {
        let memberBudgetData = copyObject(memberBudget);
        memberBudgetData.RentExpenses[index].Amount = val;
        dispatch(setMemberBudget(memberBudgetData));
    };

    return (
        <TableContainer component={Paper} sx={classes.budgetFormTable}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Typography variant="body1" component="label">
                                Rent
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {memberBudget.RentExpenses?.map((rent, index) => (
                        <TableRow key={`rent-expenses-${index}`} hover>
                            <TableCell scope="row">
                                <Grid container spacing={2}>
                                    <Grid size={4} display="flex" alignItems="center">
                                        <span>{rent.Name}</span>
                                    </Grid>
                                    <Grid size={4}>
                                        <CurrencyInput
                                            size="small"
                                            value={rent.Amount}
                                            name="Amount"
                                            onChange={(e) => handleOnChangeRentSource(e.target.value, index)}
                                        />
                                    </Grid>
                                </Grid>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default RentExpenses;
